import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricEligImprGha extends MetricBase {
    constructor() {
        super({
            field: "metric_elig_impr_gha",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.eligImprGha.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.eligImprGha.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.eligImprGha.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricEligImprGha;
